import React, {Fragment} from 'react';
import Link from 'react-router-dom/Link';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import LogoPng from '../assets/img/logo-agep-footer.png';
import LogoSvg from '../assets/img/logo-agep.svg';
import LogoSvgSimple from '../assets/img/logo-agep-simple.svg';
import LogoSvgSimpleWhite from '../assets/img/logo-agep-simple-white.svg';
import LogoWhitePng from '../assets/img/logo-agep-white.png';
import LogoWhiteSvg from '../assets/img/logo-agep-white.svg';
import LogoLepole from '../assets/img/logo-lepole.png';
import ScrollTopButton from './ScrollTopButton';

const Footer = () => (
    <Fragment>
        <footer id="site-footer">
            <div className="top">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-left col-8">
                            <div className="inner-text">
                                <p className="text-uppercase"><strong>Vous cherchez des idées de sorties pour vos élèves ?</strong></p>
                                <a className="visit-agep" href="https://www.agep.ch/" target="_blank"><i className="material-icons">keyboard_arrow_right</i> Visitez le site de l'Association Genevoise des Ecoles Privées</a>
                            </div>
                        </div>
                        <div className="col-3">
                            <a href="https://www.agep.ch/" title="AGEP" className="logo" target="_blank">
                                <object className="d-none d-md-block d-sm-none" data={LogoSvg} type="image/svg+xml">
                                    <img src={LogoPng} alt="AGEP" />
                                </object>
                                <object className="d-sm-block d-md-none d-block" data={LogoSvgSimple} type="image/svg+xml"></object>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="center">
                <div className="container">
                    <div className="row">
                        <div className="col col-sm-12 d-md-none d-block d-sm-block">
                            <span className="title">Retrouvez nos derniers séminaires</span>
                            <div className="row row-last-events">
                                <div className="col col-6">
                                    <a href="https://seminaire2016.ifp-ge.ch/" title="La pédagogie, quelle histoire!" target="_blank">
                                        <ChevronRightIcon className="m-icon" />
                                        <span className="course-date">17 mai 2016</span>
                                        <span className="course-title">La pédagogie, quelle histoire!</span>
                                    </a>
                                </div>
                                <div className="col col-6">
                                    <a href="https://pollens.ifp-ge.ch/" title="Pollens pédagogiques" target="_blank">
                                        <ChevronRightIcon className="m-icon" />
                                        <span className="course-date">8 avril 2011</span>
                                        <span className="course-title">Pollens pédagogiques</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row spaced">
                        <div className="col col-lg-4 col-md-3 col-sm-6">
                            <span className="title">L'IFP est membre de</span>
                            <a href="https://www.agep.ch/" title="AGEP" className="logo" target="_blank">
                                <object className="d-none d-lg-block d-md-none d-sm-none" data={LogoWhiteSvg} type="image/svg+xml">
                                    <img src={LogoWhitePng} alt="AGEP" />
                                </object>
                                <object className="d-sm-block d-md-block d-lg-none d-block" data={LogoSvgSimpleWhite} type="image/svg+xml"></object>
                            </a>
                        </div>
                        <div className="col col-lg-4 col-md-6 d-sm-none d-none d-md-block">
                            <span className="title">Retrouvez nos séminaires</span>

                            <div className="row row-last-events">
                                <div className="col col-4">
                                    <a href="https://pollens.ifp-ge.ch/" title="Pollens pédagogiques" target="_blank">
                                        <ChevronRightIcon className="m-icon" />
                                        <span className="course-date">8 avril 2011</span>
                                        <span className="course-title">Pollens pédagogiques</span>
                                    </a>
                                </div>
                                <div className="col col-4">
                                    <a href="https://seminaire2016.ifp-ge.ch/" title="La pédagogie, quelle histoire!" target="_blank">
                                        <ChevronRightIcon className="m-icon" />
                                        <span className="course-date">17 mai 2016</span>
                                        <span className="course-title">La pédagogie, quelle histoire!</span>
                                    </a>
                                </div>
                                <div className="col col-4">
                                    <a href="#" title="Printemps 2021" rel="noopener noreferrer">
                                        <ChevronRightIcon className="m-icon" />
                                        <span className="course-date">14 mars 2022</span>
                                        <span className="course-title">Séminaire 2022</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-4 col-md-3 col-sm-6 text-right">
                            <span className="title">Utile et pratique</span>
                            <a className="lepole-logo" href="https://lepole.education/" title="Le Pôle" target="_blank">
                                <img src={LogoLepole} alt="Le Pôle" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom d-sm-none d-none d-md-block">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <p className="copyright">COPYRIGHT &copy; IFP Institut de Formation Pédagogique - Tous droits réservés</p>
                        </div>
                        <div className="col-6">
                            <nav>
                                <ul className="clearfix">
                                    <li><Link to="/page/conditions-utilisation"><span>Conditions d'utilisation</span></Link></li>
                                    <li><Link to="/contact"><span>Contact</span></Link></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom d-md-none d-block d-sm-block">
                <div className="container">
                    <div className="row mobile-footer-links">
                        <div className="col-6"><Link to="/page/conditions-utilisation"><span>Conditions d'utilisation</span></Link></div>
                        <div className="col"><Link to="/page/contact"><span>Contact</span></Link></div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <p className="copyright">COPYRIGHT &copy; IFP Institut de Formation Pédagogique - Tous droits réservés</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <ScrollTopButton/>
    </Fragment>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/features/Layout/components/Footer.js